import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect ,useRef} from "react";

// import {ReactComponent as DialogAlert} from "../../assets/images/dialog-alert.svg";
import { ReactComponent as DialogFail } from "../../assets/images/dialog-fail.svg";
import { ReactComponent as DialogCheck } from "../../assets/images/dialog-check.svg";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";

const CopyDialog = (props) => {
  const { t } = useTranslation();
  const { password } = props;
  const [copySuccess, setCopySuccess] =  React.useState('');
  const handleClose = () => {
    props.setValue(false)
  };
  const handleClickCopyAndClose = async copyMe => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess('Copied!');
    } catch (err) {
      setCopySuccess('Failed to copy!');
    }
    props.setValue(false)
  };
  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box sx={{ position: "absolute", right: 0, margin: "20px 20px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
            {
              props.type === "fail" ?
                <DialogFail></DialogFail> : <DialogCheck></DialogCheck>
            }
            <Typography color={props.type === "fail" ? "#CC6058" : "primary"} variant="h3" mt={3}>{props.title}</Typography>
            <pre><Typography textAlign="center" mt={2}>{props.text}</Typography></pre>
            <Box mt="30px" sx={{ width: "100%", maxWidth: "300px", border: "1px solid #CED4DA", "border-radius": "4px", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Typography color="#404349" sx={{ padding: "8px" }} >{password}</Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <Button onClick={() => handleClickCopyAndClose(password)} size="large" variant="contained" sx={{ width: '200px', textTransform: "none" }} color="primary">{t(`label.copy`)}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default CopyDialog;
